// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ECY4","left":"styles_left__3nXD8"};